import { render, staticRenderFns } from "./SectionD.vue?vue&type=template&id=523c412c&scoped=true"
import script from "./SectionD.vue?vue&type=script&lang=js"
export * from "./SectionD.vue?vue&type=script&lang=js"
import style0 from "./SectionD.vue?vue&type=style&index=0&id=523c412c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c412c",
  null
  
)

export default component.exports